import { faqItems } from '@/mocks/home-data';

export default function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden"
              open
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-500 transition-colors">
                  <i className="ri-add-line group-open:ri-subtract-line text-sm transition-all"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}